import React, { Component } from "react";
import '../LandingPage/LandingPageStyleSheet.css';
import AgentConversationList from "../LandingPage/AgentConversationList";
import HWUser from "../HWLibrary/HWUser";

class LandingPageHeader extends Component {

    render() {
        const customerName = HWUser.customerFirstName();
        
       
        return (
            <div className="s360-landing-page-header" >
                <div className="s360-landing-page-header-salutation-message" style={this.headerStyle()} >
                    {this.props.config.configDetails.header} {customerName || ""}
                </div>
                <div className="s360-landing-page-header-message" style={this.headerStyle()}>
                    {this.props.config.configDetails.headerMessage}
                </div>
                {/* <div className="s360-landing-page-header-agent-container"> */}
                <AgentConversationList {...this.props} />
                {/* </div> */}
                <div className="s360-landing-page-header-information" style={this.agentIntroductoryMessage()}>
                    {this.props.config.configDetails.agentIndroductionMessage}
                </div>
            </div>
        )
    }

    headerStyle = () => {
        const design = this.props.config.designDetails;
        return {
            color: design.headerFontColor,
            fontFamily: design.headerFont,
            fontSize: design.headerFontSize+"px"

        }
    }
    agentIntroductoryMessage = () => {
        return {
            fontFamily: this.props.config.designDetails.messageFont,
            fontSize:   this.props.config.designDetails.messageFontSize+"px",
            color:      this.props.config.designDetails.messageFontColor

        }
    }

}

export default LandingPageHeader;